<template>
    <div id="lightTruck">
      <div class="container" v-if="currentImage">
        <h2  style="text-align: center">{{ currentImage.alt }}</h2>
        <img :src="currentImage.src" :alt="currentImage.alt" class="img-responsive" style="max-width: 60%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/2.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/3.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/4.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/5.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/6.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/7.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/8.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/9.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/10.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/11.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/12.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/13.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/14.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/15.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/16.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/17.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/18.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/19.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/20.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/21.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/22.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/23.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 1" :src="require('@/assets/img/qingka1/24.jpg')" style="max-width: 100%;" />

        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/2.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/3.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/4.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/5.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/6.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/7.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/8.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/9.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/10.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/11.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/12.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/13.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/14.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/15.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/16.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/17.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/18.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/19.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/20.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/21.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/22.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/23.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/24.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/25.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/26.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/27.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 2" :src="require('@/assets/img/qingka2/28.jpg')" style="max-width: 100%;" />

        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/2.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/3.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/4.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/5.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/6.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/7.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/8.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/9.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/10.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/11.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/12.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/13.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/14.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/15.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/16.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/17.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/18.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/19.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/20.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/21.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/22.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/23.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/24.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/25.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/26.jpg')" style="max-width: 100%;" />
        <img v-if="currentImage.id === 3" :src="require('@/assets/img/qingka3/27.jpg')" style="max-width: 100%;" />
        <h2 v-html="currentImage.caption"></h2>
      </div>
      <div v-else>
        <p>没有找到相关的车型信息。</p>
      </div>
    </div>
  </template>
<style scoped>
.container table {
  margin: 100 auto;
}

.container {
padding: 50px 0;
text-align: center;
}

.container > * {
margin-left: auto;
margin-right: auto;
}
/* 自定义样式 */
.container {
    padding: 50px 0;
}
img {
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
}
/* 容器居中 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
}

/* 表头样式 */
.container th {
  background-color: #0d6efd; /* 蓝色表头 */
  color: white;
  padding: 15px;
  text-align: left;
  font-weight: bold;
}

/* 表格单元格样式 */
.container td {
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

/* 隔行变色 */
.container tr:nth-child(even) {
  background-color: #f9f9f9;
}

</style>
<style>
/* 全局样式 */
/* 容器居中 + 边框 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
  border: 1px solid #ddd; /* 添加表格整体边框 */
}

/* 表头和单元格边框 */
.container th,
.container td {
  border: 1px solid #ddd; /* 所有单元格加边框 */
  padding: 8px 10px;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
}

</style>
<script>
export default {
name: 'lightTruck',
data() {
    return {
    currentImage: null,
    images: [
        {
        src: require('@/assets/img/qingka1/1.jpg'),
        alt: '解放轻卡虎6G纯电标载',
        caption: ``,

        id: 1
        },
        {
        src: require('@/assets/img/qingka2/1.jpg'),
        alt: '解放轻卡新能源2L机混动',
        caption: ``,
        id: 2
        },
        {
        src: require('@/assets/img/qingka3/1.jpg'),
        alt: '解放轻卡虎6G纯电重载',
        caption: ``,
        id: 3
        }
    ]
    };
},
mounted() {
    // 从路由参数中获取当前详情页的id
    const id = parseInt(this.$route.params.id);
    // 根据id匹配对应的图片数据
    this.currentImage = this.images.find(image => image.id === id) || null;
}
};
</script>




// WEBPACK FOOTER //
// src/view/lightTruck.vue